import { editToSegments } from './richText';

export const isUntouchedDetection = (item) => item.source === 'detected' && !item.restored && !item.modified && !item.deleted;

// Compare saved content, not only counts or a modified boolean. A second
// keystroke/move after an auto-save must schedule another save too.
export function itemFingerprint(item) {
  return JSON.stringify([
    item.type, item.textLayoutVersion, item.pageNum, item.x, item.y, item.width, item.height,
    item.w, item.h, item.x1, item.y1, item.x2, item.y2, item.points,
    item.deleted || false, item.content, item.text, item.color, item.opacity,
    item.strokeWidth, item.fontSize, item.styles,
    item.type === 'text' ? editToSegments(item) : undefined,
  ]);
}
